var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement(
      "title",
      null,
      "eu"
    ),
    React.createElement(
      "g",
      { className: styles["nc-icon-wrapper"] || "nc-icon-wrapper" },
      React.createElement("path", { fill: "#3200D0", d: "M46 6H2a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z" }),
      React.createElement("path", { fill: "#F6CF00", d: "M27.106 13.997h-2.187L24 12l-.921 1.997h-2.185l1.596 1.647-.59 2.403 2.1-1.191 2.1 1.191-.592-2.403zM33.454 16.313h-2.187l-.92-1.996-.921 1.996h-2.185l1.597 1.648-.591 2.402 2.1-1.191 2.1 1.191-.592-2.402zM27.106 31.95h-2.187L24 29.953l-.921 1.997h-2.185l1.596 1.648L21.9 36l2.1-1.191L26.1 36l-.592-2.402zM20.759 16.313h-2.187l-.919-1.996-.922 1.996h-2.185l1.597 1.648-.591 2.402 2.101-1.191 2.1 1.191-.593-2.402zM17.213 22.95h-2.187l-.92-1.997-.921 1.997H11l1.597 1.648L12.006 27l2.1-1.191 2.1 1.191-.592-2.402zM37 22.95h-2.187l-.919-1.997-.922 1.997h-2.185l1.597 1.648L31.793 27l2.101-1.191L35.993 27l-.592-2.402zM33.454 29.512h-2.187l-.92-1.996-.921 1.996h-2.185l1.597 1.648-.591 2.402 2.1-1.191 2.1 1.191-.592-2.402zM20.759 29.512h-2.187l-.919-1.996-.922 1.996h-2.185l1.597 1.648-.591 2.402 2.101-1.191 2.1 1.191-.593-2.402z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/eu-flag.svg